export const DT_EXPORT_COLUMNS = [
  {id: 'yil', label: 'Yıl'}, {id: 'ilgilenen_memur', label: 'İlgilenen Memur'},
  {id: 'piyasa_arastirma_gorevlileri', label: 'Piyasa Araştırma Görevlileri'},
  {id: 'ilce', label: 'İlçe'}, {id: 'tesis_turu', label: 'Tesis Türü'},
  {id: 'tesis_adi', label: 'Tesis Adı'}, {id: 'isin_adi', label: 'İşin Adı'},
  {id: 'alim_turu', label: 'Alım Türü'}, {id: 'talep_yeri', label: 'Talep Yeri'},
  {id: 'odenek_tutari', label: 'Ödenek Tutarı'},
  {id: 'firma1_adi', label: '1. Firma Adı'}, {id: 'firma1_teklif', label: '1. Firma Teklif'},
  {id: 'firma2_adi', label: '2. Firma Adı'}, {id: 'firma2_teklif', label: '2. Firma Teklif'},
  {id: 'firma3_adi', label: '3. Firma Adı'}, {id: 'firma3_teklif', label: '3. Firma Teklif'},
  {id: 'firma4_adi', label: '4. Firma Adı'}, {id: 'firma4_teklif', label: '4. Firma Teklif'},
  {id: 'isi_yapan_firma', label: 'İşi Yapan Firma'}, {id: 'sozlesme_bedeli', label: 'Sözleşme Bedeli'},
  {id: 'isin_suresi', label: 'İşin Süresi'}, {id: 'odeme_tarihi', label: 'Ödeme Tarihi'},
  {id: 'odeme_belge_no', label: 'Ödeme Belge No'}, {id: 'odenen_tutar', label: 'Ödenen Tutar'},
  {id: 'butce_tertibi', label: 'Bütçe Tertibi'}, {id: 'odenek_talep_tarihi', label: 'Ödenek Talep Tarihi'},
  {id: 'talep_yazi_no', label: 'Talep Yazı No'}, {id: 'odenek_durumu', label: 'Ödenek Durumu'},
  {id: 'aciklama', label: 'Açıklama'}
];

export const ISTANBUL_ILCELERI = [
  'İSTANBUL',
  'ADALAR', 'ARNAVUTKÖY', 'ATAŞEHİR', 'AVCILAR', 'BAĞCILAR', 'BAHÇELİEVLER',
  'BAKIRKÖY', 'BAŞAKŞEHİR', 'BAYRAMPAŞA', 'BEŞİKTAŞ', 'BEYKOZ', 'BEYLİKDÜZÜ',
  'BEYOĞLU', 'BÜYÜKÇEKMECE', 'ÇATALCA', 'ÇEKMEKÖY', 'ESENLER', 'ESENYURT',
  'EYÜPSULTAN', 'FATİH', 'GAZİOSMANPAŞA', 'GÜNGÖREN', 'KADIKÖY', 'KAĞITHANE',
  'KARTAL', 'KÜÇÜKÇEKMECE', 'MALTEPE', 'PENDİK', 'SANCAKTEPE', 'SARIYER',
  'SİLİVRİ', 'SULTANBEYLİ', 'SULTANGAZİ', 'ŞİLE', 'ŞİŞLİ', 'TUZLA',
  'ÜMRANİYE', 'ÜSKÜDAR', 'ZEYTİNBURNU'
];

export const BUTCE_TERTIBI_KODLARI = [
  '33.256.795.16807-9900.34-02-03.05', '33.256.795.16807-9900.34-02-03.07',
  '33.256.795.16807-9900.34-02-03.08', '33.256.795.16807-9900.34-02-06.07',
  '33.256.794.16825-9900.34-02-03.05', '33.256.794.16825-9900.34-02-03.07',
  '33.256.794.16825-9900.34-02-03.08', '33.256.794.16825-9900.34-02-06.07',
  '34.89.239.16808-9900.34-02-03.05', '34.89.239.16808-9900.34-02-03.07',
  '34.89.239.16808-9900.34-02-03.08', '34.89.239.16810-9900.34-02-06.07',
  '62.87.234.16812-9900.34-02-03.05', '62.87.234.16812-9900.34-02-03.07',
  '62.87.234.16812-9900.34-02-03.08', '62.87.234.16814-9900.34-02-06.07',
  '62.87.234.16812.9900.34.02.06.07.90.01',
  '98.900.9006.16826-9900.34-02-03.05', '98.900.9006.16826-9900.34-02-03.07',
  '98.900.9006.16826-9900.34-02-03.08', '98.900.9006.16825-9900.34-02-06.07',
  '98.900.9006.16826.9900.34.02.06.07/90.01'
];

export const INITIAL_DT_FORM_DATA = {
  yil: new Date().getFullYear().toString(),
  ilgilenen_memur: '', piyasa_arastirma_gorevlileri: [],
  ilce: '', tesis_turu: [], isin_adi: '', alim_turu: '',
  firma1_adi: '', firma1_teklif: '', firma2_adi: '', firma2_teklif: '',
  firma3_adi: '', firma3_teklif: '', firma4_adi: '', firma4_teklif: '',
  isi_yapan_firma: '', sozlesme_bedeli: '', isin_suresi: '',
  odeme_tarihi: '', odeme_belge_no: '', odenen_tutar: '',
  butce_tertibi: '', butce_tertibi_list: [],
  odenek_id: '', odenek_tutari: '', talep_yeri: '', tesis_adi: ''
};

export const INITIAL_DT_FILTERS = {
  yil: [], tesis_turu: [], ilce: [], ilgilenen_memur: [],
  talep_yeri: [], alim_turu: [], isi_yapan_firma: [],
  isin_adi: '', tesis_adi: '', odenekten_gelen: []
};
